var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { apiEndpoints } from '../../app.constants';
import { BackendHttpService } from '../../core/backend-http.service';
import { isNumber } from '@ng-bootstrap/ng-bootstrap/util/util';
import { DateUtils } from '../../utils/date.utils';
var AdminService = /** @class */ (function (_super) {
    __extends(AdminService, _super);
    function AdminService(router, translate) {
        var _this = _super.call(this, router, translate) || this;
        _this.router = router;
        _this.translate = translate;
        return _this;
    }
    AdminService.prototype.searchCompanies = function (data) {
        return this.post(apiEndpoints.searchCompanies, data);
    };
    AdminService.prototype.getNumberOfCompanies = function (data) {
        return this.post(apiEndpoints.getNumberOfCompanies, data);
    };
    AdminService.prototype.getAllCompanyType = function () {
        return this.get(apiEndpoints.getAllCompanyType);
    };
    AdminService.prototype.updatePaymentMethod = function (data) {
        return this.post(apiEndpoints.updatePaymentMethod, data);
    };
    AdminService.prototype.validateUserPaymentDetails = function (userPayment) {
        var errors = [];
        if (!userPayment.paymentId) {
            errors.push({ name: 'payment_method',
                message: this.translate.instant('user_company.please_select_payment_method') });
        }
        if (userPayment.paymentId === 'credit' && !userPayment.accountLevel) {
            errors.push({ name: 'account_level',
                message: this.translate.instant('user_company.please_select_account_level') });
        }
        return errors;
    };
    AdminService.prototype.getCreditAccountList = function () {
        return this.get(apiEndpoints.getCreditAccountList);
    };
    AdminService.prototype.saveCreditUsage = function (data) {
        return this.post(apiEndpoints.saveCreditUsage, data);
    };
    AdminService.prototype.updateNumberOfCredits = function (data) {
        return this.put(apiEndpoints.updateNumberOfCredits, data);
    };
    AdminService.prototype.getCreditUsageList = function (orderId) {
        var param = { orderId: orderId };
        return this.get(apiEndpoints.getCreditUsageList, param);
    };
    AdminService.prototype.getCreditInvoiceList = function (orderId) {
        var param = { orderId: orderId };
        return this.get(apiEndpoints.getCreditInvoiceList, param);
    };
    AdminService.prototype.createInvoice = function (data) {
        return this.post(apiEndpoints.createInvoice, data);
    };
    AdminService.prototype.updateCreditInvoice = function (data) {
        return this.put(apiEndpoints.updateCreditInvoice, data);
    };
    AdminService.prototype.validateUpdateUsageData = function (creditUsage) {
        var errors = [];
        this.validateNumber(creditUsage.numberOfSpentCredits, 'credit_amount', errors);
        if (!creditUsage.date || !DateUtils.isValidNgbDateStruct(creditUsage.date)) {
            errors.push({ name: 'date',
                message: this.translate.instant('user_and_billing.please_input_date') });
        }
        return errors;
    };
    AdminService.prototype.validateCreditAddingData = function (creditAdding) {
        var errors = [];
        this.validateNumber(creditAdding.numberOfCredits, 'credit_amount', errors);
        return errors;
    };
    AdminService.prototype.validateUploadInvoiceData = function (invoiceUpload) {
        var errors = [];
        this.validateNumber(invoiceUpload.amount, 'price_amount', errors);
        if (!invoiceUpload.invoiceDate || !DateUtils.isValidNgbDateStruct(invoiceUpload.invoiceDate)) {
            errors.push({ name: 'invoice_date',
                message: this.translate.instant('user_and_billing.please_input_date') });
        }
        if (!invoiceUpload.dueDate || !DateUtils.isValidNgbDateStruct(invoiceUpload.dueDate)) {
            errors.push({ name: 'due_date',
                message: this.translate.instant('user_and_billing.please_input_date') });
        }
        if (!invoiceUpload.invoiceNumber) {
            errors.push({ name: 'invoice_number',
                message: this.translate.instant('user_and_billing.please_input_invoice_number') });
        }
        return errors;
    };
    AdminService.prototype.validateNumber = function (numberText, fieldName, errors) {
        if (!numberText) {
            errors.push({ name: fieldName,
                message: this.translate.instant('user_and_billing.please_input_number') });
        }
        else {
            if (!isNumber(Number(numberText))) {
                errors.push({ name: fieldName,
                    message: this.translate.instant('user_and_billing.please_input_in_number_format') });
            }
            else {
                if (Number(numberText) <= 0) {
                    errors.push({ name: fieldName,
                        message: this.translate.instant('user_and_billing.please_input_in_positive_integer') });
                }
            }
        }
        return errors;
    };
    return AdminService;
}(BackendHttpService));
export { AdminService };



// WEBPACK FOOTER //
// ./src/app/services/admin/admin.service.ts.pre-build-optimizer.js